import React, { useState } from "react";
import ColumnHeader from "./ColumnHeader";
import Cell from "./Cell";
import { roundNumber } from "../../util/util";

const AvgRowTable = ({resbody, columnListData}) => {
    const [columnList, setColumnList] = useState(columnListData);
    return (
        <div className="overflow-y-auto flex-col bg-white min-h-64 max-h-64 pb-2 border-b border-gray-400 flex-grow">
            <div className="flex sticky top-0">
                {columnList.map((columnName, index) => {
                return <ColumnHeader columnName={columnName} key={index}/>
                })}
            </div>
            <div>
                { 
                resbody && 
                (resbody.resultData.map((listData, index) => {
                    return <Column listData={listData} index={index} key={index} />
                }))
                }
            </div>
        </div>
    )
}

export default AvgRowTable;

const Column = ({listData}) => {
    return (
        <div className= "flex min-w-fit text-center font-semibold">
            {
                listData && 
                <>
                    <Cell data={listData.PKCDXX.toString().replace("원지", "")}/>
                    <Cell data={listData.BSSWGH}/>
                    <Cell data={listData.HOGIXX}/>
                    <Cell data={roundNumber(listData.SBSSWG, 1)}/>
                    <Cell data={roundNumber(listData.WATERX, 2)}/>
                    <Cell data={roundNumber(listData.MILDOX, 3)}/>
                    <Cell data={roundNumber(listData.MDABGA, 2)}/>
                    <Cell data={roundNumber(listData.CDABGA, 2)}/>
                    <Cell data={roundNumber(listData.CDINDX, 2)}/>
                    <Cell data={roundNumber(listData.MDCDXX, 2)}/>
                    <Cell data={roundNumber(listData.PAGANG, 2)}/>
                    <Cell data={roundNumber(listData.PAINDX, 2)}/>
                    <Cell data={roundNumber(listData.COLORL, 2)}/>
                    <Cell data={roundNumber(listData.COLORA, 2)}/>
                    <Cell data={roundNumber(listData.COLORB, 2)}/>
                    <Cell data={listData.COBBSI}/>
                </>
            }
        </div>
      )
}